<template>
  <div>
    <div class="row mt-4" v-if="data.length > 0">
      <div class="col-md-12 mb-1">
        <label class="font-w600 ">{{ translate[lang]["extras"] }}</label>
      </div>
    </div>
    <table
      class="js-table-checkable table table-hover table-vcenter js-table-checkable-enabled"
    >
      <tbody>
        <tr
          v-for="(item, key) in data"
          :key="key"
          @click="setExtra(item, $event)"
        >
          <td style="width: 70px;" class="text-center">
            <div
              class="custom-control custom-checkbox custom-control-primary d-inline-block"
            >
              <input
                type="checkbox"
                class="custom-control-input"
                :id="'extra' + item.id"
                :name="'products[' + group + '][extras][]'"
                :value="item.id"
                :checked="item.status"
                @change="setExtra(item, $event)"
              />
              <label
                class="custom-control-label"
                :for="'extra' + item.id"
              ></label>
            </div>
          </td>
          <td width="20%" v-if="item.img_path">
            <img class="img-fluid w-50" :src="item.img_path" />
          </td>
          <td class="d-sm-table-cell">
            {{ item.title[lang] }}
          </td>
          <td
            width="20%"
            class="text-right d-sm-table-cell"
            style="white-space: nowrap"
          >
            € {{ formatPrice(item.rate) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "Extras",
  props: ["data", "product", "group"],
  data() {
    return {
      extra: 0,
      packageTotal: 0
    };
  },
  methods: {
    setExtra(item, e) {
      let overview = this.filterOverview(this.product);
      if (item.status === 0) {
        item.status = 1;
        overview.total += parseFloat(item.rate);
        overview.yearly += parseFloat(item.rate) * 12;
      } else {
        if (item.status === 1 && !e.target.checked) {
          item.status = 1;
        }

        item.status = 0;
        overview.total -= parseFloat(item.rate);
        overview.yearly -= parseFloat(item.rate) * 12;
      }
    }
  }
};
</script>

<style scoped></style>
